import React from 'react'
import { Field, Form, Formik } from 'formik'
import * as yup from 'yup'
import styled from 'styled-components'

import Button from './Button'
import Container from './Container'
import TextField from './TextField'
import Text from './Text'

import logo from '../assets/images/logo.svg'
import { signIn } from '../firebase/auth'

const Logo = styled.img`
  height: 10rem;
  display: block;
  width: 50%;
  margin: ${props => props.theme.space[1]}rem auto;
`

const LoginForm = styled(Form)`
  width: 100%;
  max-width: 25rem;
  margin: 0 auto;
`

const loginSchema = yup.object().shape({
  emailAddress: yup.string().required('Please enter an email address').email('Email address is not valid'),
  password: yup.string().required('Please enter a password')
})

const INITIAL_VALUES = {
  emailAddress: '',
  password: ''
}

class Login extends React.PureComponent {
  state = {
    loading: false
  }

  _onSubmit = async (values, {setSubmitting}) => {
    try {
      await signIn(values.emailAddress, values.password)
    } catch (e) {
      this.setState({error: e.message})
    }
    setSubmitting(false)
  }

  render () {
    const {error} = this.state
    return (
      <Container>
        <Logo src={logo} />
        <Formik
          initialValues={INITIAL_VALUES}
          validationSchema={loginSchema}
          onSubmit={(values, actions) => this._onSubmit(values, actions)}>
          {({isSubmitting}) =>
            <LoginForm>
              <Field component={TextField} name='emailAddress' />
              <Field component={TextField} name='password' type='password' />
              {error && <Text mb={3} textAlign='center' error>{error}</Text>}
              <Button type='submit' fluid disabled={isSubmitting}>Login</Button>
            </LoginForm>}
        </Formik>
      </Container>
    )
  }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Login.js